module.exports = __webpack_public_path__ + "img/VG.3c6673e0.svg";